import * as _createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Output, NgZone } from '@angular/core';
import { IAddUnit } from './upsell-config';
import { INumberInputMask, createNumberMask } from '../../lib/forms';

@Component({
  selector: 'hardware-unit',
  templateUrl: './hardware-unit.component.html',
  styleUrls: ['./hardware-unit.component.scss', '../../styles/upgrade.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HardwareUnitComponent {
  public numberOnlyMask: INumberInputMask = createNumberMask(2, null);
  @Input() public unit: IAddUnit;
  @Input() public subscription: string;
  @Input() public MIN_QUANTITY: number;
  @Input() public MAX_QUANTITY: number;
  @Output() public updateUnitEvent = new EventEmitter<IAddUnit>();

  constructor(private cdr: ChangeDetectorRef, private ngZone: NgZone) {}

  public decrementQuantity(event, unit: IAddUnit): void {
    const input = event.target.nextElementSibling.querySelector('input');
    const inputValue = this.isEmpty(input.value) ? this.MIN_QUANTITY : parseInt(input.value, 10);

    if (inputValue > this.MIN_QUANTITY) {
      input.value = inputValue - 1;
      this.updateUnitAttributes(unit, input.value);
    }
  }

  public incrementQuantity(event, unit: IAddUnit): void {
    const input = event.target.previousElementSibling.querySelector('input');
    const inputValue = this.isEmpty(input.value) ? this.MIN_QUANTITY : parseInt(input.value, 10);

    if (inputValue < this.MAX_QUANTITY) {
      input.value = inputValue + 1;
      this.updateUnitAttributes(unit, input.value);
    }
  }

  public inputQuantity(event, unit: IAddUnit): void {
    const target = event.target;
    const value = parseInt(target.value, 10) ;

    if (value < this.MIN_QUANTITY || isNaN(value)) {
      target.value = this.MIN_QUANTITY;
    } else if (value > this.MAX_QUANTITY ) {
      target.value = this.MAX_QUANTITY;
    } else {
      target.value = value;
    }
    this.updateUnitAttributes(unit, target.value);
  }

  public updateUnitAttributes(unit: IAddUnit, value: number): void {
    this.updateUnitQuantity(unit, value);
    this.updateUnitPardotField(unit, value);
    this.emitUnit(unit);
  }

  public updateUnitQuantity(unit: IAddUnit, value: number): void {
    unit.quantity = value;
  }

  public updateUnitPardotField(unit: IAddUnit, value: number): void {
    if (value > this.MIN_QUANTITY) {
      unit.pardotField = `Product: ${unit.title} - Subscription: ${this.subscription} - Quantity: ${value}`;
    } else {
      unit.pardotField = null;
    }
  }

  public emitUnit(unit: IAddUnit): void {
    this.ngZone.run(() => {
      this.updateUnitEvent.emit(unit);
      this.cdr.markForCheck();
    });
  }

  public isEmpty(value: string): boolean {
    // check if number only field is empty
    return isNaN(parseInt(value, 10));
  }
}
